import { createContext, useContext } from 'react'

export type TDashboardHeaderApi = {
  // Whether the widget's own scroll container has been scrolled away from the top. On dashboards
  // whose table scrolls internally the page barely moves, so this is what tells the header to
  // compact — window scroll would never fire.
  setScrolled: (scrolled: boolean) => void
  // The resulting compact state, passed back down so the widget's own header can tighten in step
  // with the page header rather than each deciding separately.
  compact: boolean
}

/**
 * Lets a widget that owns its own scroll region drive the page header's compact state.
 *
 * Only provided by shells that opt in. Widgets elsewhere see no provider and report nothing, so
 * dashboards that still scroll the page are unaffected.
 */
export const DashboardHeaderContext = createContext<TDashboardHeaderApi | null>(null)

export const useDashboardHeader = () => useContext(DashboardHeaderContext)
